/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AttentionDto,
  ProblemDetails
} from '.././model';

import { request } from '../../http-client';




export const getApiV1Attention = (
    
 signal?: AbortSignal
) => {
      
      
      return request<AttentionDto>(
      {url: `/api/v1/attention`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1AttentionQueryKey = () => {
    return [
    `/api/v1/attention`
    ] as const;
    }

    
export const getGetApiV1AttentionQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Attention>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Attention>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1AttentionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Attention>>> = ({ signal }) => getApiV1Attention(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Attention>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1AttentionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Attention>>>
export type GetApiV1AttentionQueryError = ProblemDetails


export function useGetApiV1Attention<TData = Awaited<ReturnType<typeof getApiV1Attention>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Attention>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Attention>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Attention>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Attention<TData = Awaited<ReturnType<typeof getApiV1Attention>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Attention>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Attention>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Attention>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Attention<TData = Awaited<ReturnType<typeof getApiV1Attention>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Attention>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Attention<TData = Awaited<ReturnType<typeof getApiV1Attention>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Attention>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1AttentionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




